import { CONFIG } from './config'

export const ORTHOGRAPHY = [
  'a',
  'ă',
  'â',
  'b',
  'c',
  'd',
  'đ',
  'e',
  'ê',
  'g',
  'h',
  'i',
  'k',
  'l',
  'm',
  'n',
  'o',
  'ơ',
  'ô',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'ư',
  'v',
  'x',
  'y',
  'ch',
  'tr',
  'kh',
  'nh',
  'th',
  'ph',
  'ng',
  'ngh',
  'qu',
  'gi',
  ' ',
  'w',
  'z',
  'j',
  'f',
  'á',
  'ắ',
  'ấ',
  'à',
  'ầ',
  'ả',
  'ẳ',
  'ằ',
  'ẩ',
  'ã',
  'ẵ',
  'ẫ',
  'ạ',
  'ặ',
  'ậ',
  'è',
  'ẻ',
  'ẽ',
  'é',
  'ẹ',
  'ề',
  'ể',
  'ễ',
  'ế',
  'ệ',
  'ì',
  'ỉ',
  'ĩ',
  'í',
  'ị',
  'ò',
  'ỏ',
  'õ',
  'ó',
  'ọ',
  'ồ',
  'ổ',
  'ỗ',
  'ố',
  'ộ',
  'ờ',
  'ở',
  'ỡ',
  'ớ',
  'ợ',
  'ù',
  'ủ',
  'ũ',
  'ú',
  'ụ',
  'ứ',
  'ử',
  'ữ',
  'ừ',
  'ự',
  'ỷ',
  'ỵ',
  'ỹ',
  'ý',
  'ỳ',
  '-',
]

if (CONFIG.normalization) {
  ORTHOGRAPHY.forEach(
    (val, i) => (ORTHOGRAPHY[i] = val.normalize(CONFIG.normalization))
  )
}
